import { render, staticRenderFns } from "./course-center-list.vue?vue&type=template&id=718641bd"
import script from "./course-center-list.vue?vue&type=script&lang=ts"
export * from "./course-center-list.vue?vue&type=script&lang=ts"
import style0 from "./course-center-list.vue?vue&type=style&index=0&id=718641bd&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports